import moment from 'moment';

const Data = {
  dataFormat: (data, format = 'DD/MM/YYYY') => {
    if (!data) return '';

    return moment(data).format(format);
  },
  dataFinalCampanha: (dataInicio, dias, meses, format) => {
    if (!dataInicio || !dias || !meses) return '';

    const data = moment(dataInicio)
      .add(dias * meses, 'days')
      .subtract(1, 'days');

    if (format) return data.format('DD/MM/YYYY');

    return data;
  },
  dataAtualOuFinalCampanha: (dataInicio, dias, meses) => {
    let dataFinal = moment(dataInicio)
      .add(dias * meses, 'days')
      .subtract(1, 'days');
    let hoje = moment();

    if (hoje.diff(dataFinal, 'days') < 0) return hoje;

    return dataFinal;
  },
  periodoDaCampanha: (dataInicio, dias, meses) => {
    if (!dataInicio) return 1;

    let inicio = moment(dataInicio);
    let hoje = moment();

    const periodo = parseInt(hoje.diff(inicio, 'days') / dias + 1);

    if (periodo >= meses) return meses;

    return periodo;
  },
  dataInicioPeriodoAtual: (dataInicio, dias, meses) => {
    if (!dataInicio || !meses) return '';
    const periodo = Data.periodoDaCampanha(dataInicio, dias, meses);

    return moment(dataInicio).add(dias * (periodo - 1), 'days');
  },
  dataFimPeriodoAtual: (dataInicio, dias) => {
    if (!dataInicio) return '';

    return moment(dataInicio).add(dias - 1, 'days');
  },
  diasPassadosPeriodo: (dataInicio, unidade = 'days') => {
    if (!dataInicio) return 1;

    let inicio = moment(dataInicio);
    let hoje = moment();

    return hoje.diff(inicio, unidade) + 1;
  },
  dataPassada: (data) => {
    if (!data) return false;

    return moment(data).isBefore(moment());
  },
  dataFutura: (data) => {
    if (!data) return false;

    return moment(data).isSameOrAfter(moment());
  },
  validaFimDeSemanaData: (dataParcela, parcela) => {
    const data = moment(dataParcela).add(parcela, 'M');
    const diaSemana = data.isoWeekday();

    if ([6, 7].includes(diaSemana))
      return data.isoWeekday(5).format('DD/MM/YYYY');

    return data.format('DD/MM/YYYY');
  },
  momentToDate: (data) => {
    if (!data) return undefined;

    return moment(data).toDate();
  },
};

export default Data;
